import { render, staticRenderFns } from "./DailyCustomer.vue?vue&type=template&id=344b6b84&"
import script from "./DailyCustomer.vue?vue&type=script&lang=js&"
export * from "./DailyCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports